import angular from "angular";

import AdminProfileModuleRouting from "./admin-profile.module.routing";

export default angular
  .module("vt-admin-profile", [])
  .config(AdminProfileModuleRouting);
